import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getContentTaggingEnabled } from '../../../redux/modules/auth';
import {
  VpHookFormWrapper,
  VpAutoSave,
  VpMediaTitleInput,
  VpMediaDescriptionInput,
  VpMediaTagInput,
  VpMediaTranscriptionInput,
  VpMediaFileSizeInput,
  VpMediaNameInput
} from '../../';
import { useUpdateMediaDetails } from '../../../hooks/';
import { getFileSizeLabel, extractThumbnailPath } from '../../../utils';
import { useUpdateAttachmentDetails } from '../../../hooks/react-query/useAttachmentData';
import VpConditionalUpgradeWrapper from '../../components/VpConditionalUpgradeWrapper/VpConditionalUpgradeWrapper';

export const VpMediaInfoDetails = ({ media, contentTaggingEnabled }) => {
  const isVideo = !!media?.mediaId;
  const fileSizeLabel = !isVideo && getFileSizeLabel(media?.fileSize);

  const { mutate: updateMediaData } = useUpdateMediaDetails();
  const { mutate: updateAttachmentData } = useUpdateAttachmentDetails();

  const defaultValues = {
    title: media?.mediaTitle || media?.attachmentTitle,
    description: media?.mediaDescription || media?.attachmentDescription,
    thumbnailUrl: media?.thumbnailUrl
  };

  const onSubmit = (values) => {
    const data = {
      title: values?.title || '',
      description: values?.description || ''
    };
    if (isVideo) {
      const thumbnailToUse = values?.thumbnailUrl || media?.thumbnailUrl;
      const thumbnailUrl = extractThumbnailPath(thumbnailToUse);
      data.thumbnailUrl = thumbnailUrl;
      updateMediaData({ data, mediaId: media?.mediaId });
    } else {
      updateAttachmentData({ data, attachmentId: media?.attachmentId });
    }
  };
  const defaultInputFields = (
    <>
      <VpConditionalUpgradeWrapper condition={!contentTaggingEnabled} disableFlex>
        {({ isDisabled }) => (
          <VpMediaTagInput
            value={media?.tags}
            mediaId={media?.mediaId || media?.attachmentId}
            isVideo={isVideo}
            disabled={isDisabled}
          />
        )}
      </VpConditionalUpgradeWrapper>

      <VpMediaTitleInput defaultValue={media?.mediaTitle || media?.attachmentTitle} />
      <VpMediaDescriptionInput
        defaultValue={media?.mediaDescription || media?.attachmentDescription}
      />
    </>
  );
  return (
    <VpHookFormWrapper onSubmit={onSubmit}>
      {defaultInputFields}
      {isVideo ? (
        <VpMediaTranscriptionInput media={media} />
      ) : (
        <>
          <VpMediaNameInput value={media?.originalFileName} />
          <VpMediaFileSizeInput value={fileSizeLabel} />
        </>
      )}
      <VpAutoSave onSubmit={onSubmit} defaultValues={defaultValues} />
    </VpHookFormWrapper>
  );
};

VpMediaInfoDetails.propTypes = {
  media: PropTypes.shape({
    attachmentTitle: PropTypes.string,
    mediaTitle: PropTypes.string,
    mediaDescription: PropTypes.string,
    attachmentDescription: PropTypes.string,
    mediaUrl: PropTypes.string,
    mediaId: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    path: PropTypes.string,
    attachmentId: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.object),
    originalFileName: PropTypes.string,
    fileSize: PropTypes.string
  }),
  contentTaggingEnabled: PropTypes.bool
};

const mapStateToProps = (state) => ({
  contentTaggingEnabled: getContentTaggingEnabled(state)
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(VpMediaInfoDetails);



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaInfoDetails.jsx